module.exports = __webpack_public_path__ + "static/media/Minerva McGonagall 2.d1fe73bb.jpg";